import { sendFavoritesEvent } from '$lib/services/gtm/methods';

import { sendStats } from '@api/user/stats';
import type { AddFavoriteData } from '@components/favorite/types';
import { EventCategory, EventType, UserType } from '@shared/types';

export const sendEvents = (
    added: boolean,
    desktop: boolean,
    isOperator: boolean,
    place: AddFavoriteData['place'],
    userId: string,
    modelId: string,
    roomId?: string
) => {
    if (added) {
        sendFavoritesEvent({
            event: EventType.UserAddFavorites,
            place,
            type: isOperator ? UserType.Model : UserType.User,
        });
        sendStats(EventType.UserAddFavorites, EventCategory.Favorites, desktop, {
            favorites: {
                room_id: roomId,
                model_id: modelId,
                user_id: userId,
                who_added: isOperator ? UserType.Model : UserType.User,
            },
        });
    } else {
        sendFavoritesEvent({
            event: 'user_delete_favorites',
            place,
            type: isOperator ? UserType.Model : UserType.User,
        });
    }
};
